import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import MainTemplate from 'pages/templates/MainTemplate';

import BasicModal from 'components/organisms/Modal/Basic';
import BasicModalHeader from 'components/molecules/Modal/Header';
import BasicModalSection from 'components/molecules/Modal/Section';
import BasicModalFooter from 'components/molecules/Modal/Footer';

import TextInput from 'components/atoms/TextInput';

const RealTimeAdList = () => {
  // 공통
  const { t } = useTranslation();

  // 계정관리 비밀번호 입력 모달 관련
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <MainTemplate>
      <h2>실시간 광고 송출 리스트</h2>
      <BasicModal open={open}>
        <BasicModalHeader
          headerOpen={true}
          headerTitle={t('계정관리')}
          closeBtn={true}
          closeOnClick={handleClose}
        />
        <BasicModalSection
          textContent={t(
            '계정 관리 페이지로 이동하려면 비밀번호를 재임력 해주시기 바랍니다.'
          )}
        >
          <TextInput
            id={'sampleId'}
            label={t('비밀번호')}
            error={false}
            errorMessageOpen={false}
            errorMessage={t('error message')}
          ></TextInput>
        </BasicModalSection>
        <BasicModalFooter
          cancelOnClick={handleClose}
          cancelBtnOpen={true}
          cancelBtnTitle={t('확인')}
          confirmOnClick={handleClose}
          confirmBtnOpen={true}
          confirmBtnTitle={t('확인')}
        />
      </BasicModal>
    </MainTemplate>
  );
};

export default RealTimeAdList;
